import { requestBuilder } from '../../http/RequestBuilder';

export interface SpinwheelConnectRequest {
    dateOfBirth: string; // Format: "1999-03-27"
    extUserId: string;
    phoneNumber: string; // Format: "+15556300698"
    isPhoneNumberReset?: boolean; // Indicates if this request is from phone reset page
}

export interface SpinwheelConnectResponse {
    // TODO: Add response structure as needed
    success: boolean;
    spinwheelUserId?: string;
}

export const useSpinwheelConnect = requestBuilder.mutation<
    SpinwheelConnectResponse,
    SpinwheelConnectRequest
>({
    endpoint: '/api/spinwheel/connect-sms',
    method: 'POST',
});
